import React from 'react'

const StarIco = ({ width, height }) => {
    return (
        <>
            <svg width={width} height={height} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.52106 13.3184C9.20104 13.1229 8.79856 13.1229 8.47854 13.3184L5.1738 15.3369C4.4147 15.8006 3.47344 15.1167 3.67983 14.2515L4.57835 10.4847C4.66535 10.12 4.54098 9.7372 4.2562 9.49324L1.3152 6.97395C0.639667 6.39528 0.999193 5.28878 1.88585 5.2177L5.74594 4.90823C6.11973 4.87826 6.44534 4.64169 6.58935 4.29546L8.07649 0.719913C8.41808 -0.101378 9.58153 -0.101386 9.92313 0.7199L11.4103 4.29547C11.5543 4.6417 11.8799 4.87826 12.2537 4.90823L16.1138 5.21769C17.0005 5.28878 17.36 6.39528 16.6845 6.97395L13.7435 9.49324C13.4587 9.7372 13.3343 10.12 13.4213 10.4847L14.3198 14.2515C14.5262 15.1168 13.585 15.8006 12.8259 15.337L9.52106 13.3184Z" fill="currentColor" />
            </svg>
        </>
    )
}

export default StarIco;